import { render, staticRenderFns } from "./QNewRecruitsDrilldown.vue?vue&type=template&id=edcd4bc4&scoped=true&"
import script from "./QNewRecruitsDrilldown.vue?vue&type=script&lang=js&"
export * from "./QNewRecruitsDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcd4bc4",
  null
  
)

export default component.exports